import React from 'react';
import {
    Dropdown,
    Option,
    Field,
    Spinner,
    Text
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import RequiredLabel from './RequiredLabel';
import { EmailDocumentCategoryResult } from '../../../services/api/dataServiceOutlookQuickSave';

interface CategoryDropdownProps {
    categories: EmailDocumentCategoryResult[];
    selectedCategory: EmailDocumentCategoryResult | null;
    isLoading: boolean;
    error: string;
    disabled?: boolean;
    required?: boolean;
    onCategoryChange: (category: EmailDocumentCategoryResult | null) => void;
}

const CategoryDropdown: React.FC<CategoryDropdownProps> = ({
    categories,
    selectedCategory,
    isLoading,
    error,
    disabled = false,
    required = false,
    onCategoryChange
}) => {
    const { t } = useTranslation();

    const handleOptionSelect = (_event: unknown, data: { optionValue?: string }) => {
        const selectedCategoryRecno = data.optionValue;
        if (selectedCategoryRecno) {
            const category = categories.find(c => c.Recno.toString() === selectedCategoryRecno);
            onCategoryChange(category || null);
        } else {
            onCategoryChange(null);
        }
    };

    return (
        <Field
            label={<RequiredLabel text={t("Category")} required={required} />}
            validationMessage={error || undefined}
            validationState={error ? "error" : "none"}
        >
            {isLoading ? (
                <div>
                    <Spinner size="small" />
                    <Text>{t("Loading...")}</Text>
                </div>
            ) : (
                <Dropdown
                    placeholder={t("Select a category")}
                    value={selectedCategory?.Description || ''}
                    selectedOptions={selectedCategory ? [selectedCategory.Recno.toString()] : []}
                    onOptionSelect={handleOptionSelect}
                    disabled={disabled}
                >
                    {categories.map((category) => (
                        <Option
                            key={category.Recno}
                            value={category.Recno.toString()}
                            text={category.Description}
                        >
                            {category.Description}
                        </Option>
                    ))}
                </Dropdown>
            )}
        </Field>
    );
};

export { CategoryDropdown };
export default CategoryDropdown;
